import { StringHelper } from './string-helper';
import Employee from '../model/product/employee';
import { CollectionHelper } from './collection-helper';

export default class EmployeeHelper {
  private constructor() {}

  public static getName(e: Employee): string {
    return e.user == null
      ? null
      : StringHelper.join(
          [
            e.user.firstName == null ? null : e.user.firstName.toString(),
            e.user.lastName == null ? null : e.user.lastName.toString()
          ],
          ' '
        );
  }

  public static getNames(employees: Employee[], sep = ', '): string {
    if (!CollectionHelper.isPopulated(employees)) {
      return '';
    }
    return StringHelper.join(employees.map(e => this.getName(e)), sep);
  }
}
